module.exports = __webpack_public_path__ + "img/coupon_back.21c58327.png";